module.exports = __webpack_public_path__ + "img/gold-medal.5c575af1.gif";